/**
 * Newsletter prompts hide for 24 hours after a subscribe, so someone who has just signed up is
 * not asked again on the next page.
 *
 * Two keys, named after the localStorage entries they hold so there is nothing to decode. Both
 * are written on every subscribe and so always carry the same value - the split is historical,
 * from when the nav bar tracked its suppression separately from the in-page signups
 */

export const NAV_SUBSCRIBED_DATE = 'navSubscribedDate';
export const NEWSLETTER_SUBSCRIBED_DATE = 'newsletterSubscribedDate';

const SUPPRESSION_WINDOW_MS = 24 * 60 * 60 * 1000;

/**
 * @param  {String} key NAV_SUBSCRIBED_DATE or NEWSLETTER_SUBSCRIBED_DATE
 * @return {Boolean} A subscribe was recorded against this key inside the last 24 hours
 */
export const subscribedWithinWindow = (key) => {
  const subscribedAt = Number(localStorage.getItem(key));
  if (!subscribedAt) {
    return false;
  }
  return (Date.now() - subscribedAt) <= SUPPRESSION_WINDOW_MS;
};

/** Record a subscribe against both suppression keys */
export const recordSubscribe = () => {
  const now = Date.now();
  localStorage.setItem(NAV_SUBSCRIBED_DATE, now);
  localStorage.setItem(NEWSLETTER_SUBSCRIBED_DATE, now);
};
